import { render, staticRenderFns } from "./OptimizationGroupEdit.vue?vue&type=template&id=2608eb92"
import script from "./OptimizationGroupEdit.vue?vue&type=script&lang=js"
export * from "./OptimizationGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports